<template>
  <Dialog class="mobile act-time-dialog" :modelValue="state.visible" type="share" :showClose="false" :class="type" style="z-index: 100;">
    <div class="share-dialog-content" :class="locale">
      <div>
        {{ $t('mwr.actTimeDialogText') }}
      </div>
      <div v-if="locale === 'th'">
        {{ $t('mwr.actTimeDialogText2') }}
      </div>
      <!-- <img src="~@/assets/imgs/act/mwr/share/facebook.png" @click="shareToFB" alt="facebook">
      <img src="~@/assets/imgs/act/mwr/share/x.png" @click="shareToX" alt="x(twitter)">
      <img src="~@/assets/imgs/act/mwr/share/whatsapp.png" @click="shareToWhatsApp" alt="whatsapp"> -->
      <!-- <button @click="shareToFB">facebook</button>
      <button @click="shareToX">x(twitter)</button>
      <button @click="shareToWhatsApp">whatsapp</button> -->
    </div>
  </Dialog>
</template>

<script setup>
  /* eslint-disable */
import Dialog from '@/components/Dialog/ActMwr/index.vue'
import { defineProps, defineEmits, reactive, inject, watch } from 'vue'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const mwrData = inject('mwrData')
const props = defineProps({
  type: { // normal, shareDragon
    type: String,
    default: 'normal'
  }
})

const state = reactive({
  visible: false
})

watch(() => mwrData.showActTimeDialog, (newVal) => {
  if (newVal) {
    state.visible = true
  } else {
    state.visible = false
  }
}, { immediate: true })


</script>

<style lang="less" scoped src="./mobile_style.less"></style>

